import classNames from "classnames";
import Logo from "pages/login/_components/Logo";
import Step3Content from "pages/login/_components/Step3Content";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import withExchangeToken from "pages/_components/withExchangeToken";
import { bool, func, number, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { push } from "react-router-redux/actions";
import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { selectors as sessionSelectors } from "reducers/session";
import { compose } from "redux";

class LoginStep3 extends Component {
    componentDidMount() {
        const { dispatch, activeEnvironment, username } = this.props;
        if (activeEnvironment) {
            dispatch(push("/desktop"));
        } else if (!username) {
            dispatch(push("/"));
        }
    }

    onHeaderClose = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
        dispatch(push("/"));
    };

    render() {
        const { isDesktop, userFirstName } = this.props;

        return (
            <>
                {isDesktop && (
                    <Head
                        additionalClassName="special-header-login"
                        logo={<Logo isDesktop={isDesktop} className="svg-image logo" />}
                        replace={{
                            USER_NAME:
                                userFirstName && userFirstName.length > 1
                                    ? userFirstName
                                          .split(" ")
                                          .map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
                                          .join(" ")
                                    : "",
                        }}
                        accessibilityTextId="activities.session.login.step3.a11y"
                        onClose={this.onHeaderClose}
                        flex
                    />
                )}
                {!isDesktop && (
                    <Head
                        onClose={this.onHeaderClose}
                        logo={<Logo isDesktop={isDesktop} className="svg-image logo" />}
                    />
                )}
                <Notification scopeToShow="loginStep3" />
                <MainContainer
                    className={classNames("main-container", {
                        "container-fluid with-special-header-login": isDesktop,
                    })}>
                    <Step3Content className={classNames("app-default-main styled-2")} />
                </MainContainer>
            </>
        );
    }
}

LoginStep3.propTypes = {
    isDesktop: bool.isRequired,
    userFirstName: string.isRequired,
    dispatch: func.isRequired,
    username: string.isRequired,
    activeEnvironment: number,
};

LoginStep3.defaultProps = {
    activeEnvironment: null,
};

const mapStateToProps = (state) => ({
    userFirstName: loginSelectors.getUserFirstName(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    username: loginSelectors.getUsername(state),
});

export default compose(withRouter, connect(mapStateToProps))(withExchangeToken(LoginStep3));
